// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3EnyS","file":"styles_file__2a2jw"};